import {doc} from './docs.js';

doc(
    "averageDistance",
    {a:"",b:""},
    "Computes average distance",
    undefined,
    {
        inlets: 2
    });
export const averageDistance = (object, b) => {
    return ([a]) => {
        // given 2 arrays calculate the avg distance
        let _b = b();

        let sum = 0;

        if (!a || !_b) {
            return 0;
        }
        for (let i=0; i < a.length; i+=2) {
            let xA = a[i];
            let yA = a[i+1];
            let xB = _b[i];
            let yB = _b[i+1];

            let dist = Math.sqrt(Math.pow(xA - xB, 2) + Math.pow(yA - yB, 2));
            sum += dist;
        }
        return sum / (a.length / 2);
    };
};

doc(
    "average",
    {list:"",b:""},
    "Computes average of list",
    undefined,
    {
        inlets: 1
    });
export const average = (object) => {
    return ([a]) => {
        // given 2 arrays calculate the avg distance
        let sum = 0;

        if (!a) {
            return 0;
        }
        for (let i=0; i < a.length; i++) {
            sum += a[i];
        }
        return sum / (a.length);
    };
};

